import gql from 'graphql-tag';

export default gql`
  query ManageEnrollSubjectPage($subject: MongoID!, $page: Int, $perPage: Int) {
    manageEnrollSubjectPage(subject: $subject, page: $page, perPage: $perPage, includeDetails: false) {
      items {
        _id
        student {
          _id
          email
          mobile
          firstname
          lastname
          role
          avatar
        }
        certificatestatus
        creditstatus
        time
        name
        status
      }
      progresses {
        _id
        studentId
        contentId
        progress
        zoomprogress
        certificateProgress
      }
      total
      page
      perPage
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;
